// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"762":"b3421d5e","1042":"72cdd6d9","2867":"c3a71a48","7387":"72cdd6d9"}[chunkId] + ".chunk.css";
};